import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    totalTrips: 0,
    totalRevenue: "0.00",
    ongoingTrips: 0,
    successfulTrips: 0,
    cancelledTrips: 0,
    dashboardSummary: {},
    totalTripsInPerntage: 0,
    totalRevenueInPerntage: 0,
    ongoingTripsInPerntage: 0,
    successfulTripsInPerntage: 0,
    cancelledTripsInPerntage: 0,
    trendInTotalTrips: "",
    trendInTotalRevenue: "",
    trendInOngoingTrips: "",
    trendInSuccessfulTrips: "",
    trendInCancelledTrips: "",
    loading: false,
    error: false,
    errorMessage: "",
};

const TripDashboard = createSlice({
    name: "tripDashboard",
    initialState,
    reducers: {
        setTripDashboardData(state, action) {
            const data = action.payload;

            state.totalTrips = data.total_trips;
            state.totalRevenue = data.total_revenue;
            state.ongoingTrips = data.ongoing_trips;
            state.successfulTrips = data.successful_trips;
            state.cancelledTrips = data.cancelled_trips;
            state.totalTripsInPerntage = data.dashboard_summary?.dashboard_summary.total_trips?.change_percent;
            state.totalRevenueInPerntage = data.dashboard_summary?.dashboard_summary.total_revenue?.change_percent;
            state.ongoingTripsInPerntage = data.dashboard_summary?.dashboard_summary.ongoing_trips?.change_percent;
            state.successfulTripsInPerntage = data.dashboard_summary?.dashboard_summary.successful_trips?.change_percent;
            state.cancelledTripsInPerntage = data.dashboard_summary?.dashboard_summary.cancelled_trips?.change_percent;
            state.trendInTotalTrips = data.dashboard_summary?.dashboard_summary.total_trips?.trend;
            state.trendInTotalRevenue = data.dashboard_summary?.dashboard_summary.total_revenue?.trend;
            state.trendInOngoingTrips = data.dashboard_summary?.dashboard_summary.ongoing_trips?.trend;
            state.trendInSuccessfulTrips = data.dashboard_summary?.dashboard_summary.successful_trips?.trend;
            state.trendInCancelledTrips = data.dashboard_summary?.dashboard_summary.cancelled_trips?.trend;
            state.dashboardSummary = data.dashboard_summary?.dashboard_summary || {};
            state.loading = false;
            state.error = false;
        },
        loadingTripDashboard(state, action) {
            state.loading = action.payload;
        },
        tripDashboardError(state, action) {
            state.error = true;
            state.errorMessage = action.payload;
            state.loading = false;
        },
        
        clearTripDashboardError(state) {
            state.error = false;
            state.errorMessage = "";
        },
    },
});

export const {
    setTripDashboardData,
    loadingTripDashboard,
    tripDashboardError,
    clearTripDashboardError,
} = TripDashboard.actions;

export default TripDashboard.reducer;
